module.exports = __webpack_public_path__ + "static/img/floatRightImg1.2a55125.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/floatRightImg1.png
// module id = sTvZ
// module chunks = 2